import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';
import { AuthGate } from '@/components/AuthGate';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { signOut } from '@/lib/auth';

/**
 * Settings route.
 *
 * Panels: account sign-out only.
 *
 * F-08 follow-up (提案者: 凜さん 2026-07-04、Issue #1070): the "AI プロバイダ"
 * card (cloud/local toggle) was removed — its only local execution path
 * (`streamLocalChat`) was orphaned by the developer-console removal (#1069)
 * and the toggle became a facade with no backing implementation. Local-LLM
 * (llama.cpp sidecar) support was removed outright rather than re-wired.
 *
 * S-DT-01 (判定ボード D-1「Tauri 完全撤収」、提案者: Claude、凜さん判定
 * 2026-07-05): the Tauri-desktop-only "デスクトップ" card (global hotkey /
 * OS notifications / updater) was removed together with the Tauri shell —
 * on the web build `isTauriDesktop()` was always false, so the card never
 * rendered and the whole chain was unreachable code.
 */
function SettingsIndex() {
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    await navigate({ to: '/signin', replace: true });
  }

  return (
    <AppShell>
      <div className="p-6 max-w-2xl mx-auto flex flex-col gap-4">
        <h1 className="text-2xl font-semibold">設定</h1>

        <Card>
          <CardHeader>
            <CardTitle>アカウント</CardTitle>
            <CardDescription>サインアウトはこちらから。</CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-3">
            <Button variant="outline" onClick={handleSignOut}>
              サインアウト
            </Button>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}

function SettingsRouteComponent() {
  return (
    <AuthGate>
      <SettingsIndex />
    </AuthGate>
  );
}

export const Route = createFileRoute('/settings')({
  component: SettingsRouteComponent,
});
